/**
 * A value which can be included in a job's searchable text.  Nullish/empty values are ignored when searching.
 */
export type SearchableValue = string | number | boolean | null | undefined;

/**
 * Determines whether a set of job values matches a search query.  The query is split into terms on whitespace and
 * every term must appear (case-insensitively) somewhere in the job's values, so terms can be combined to narrow
 * results (e.g. "daily append" matches jobs which are both synced daily and appended).
 * @param values the searchable values of the job (raw and display values)
 * @param query the raw search query typed by the user
 */
export const matchesSearchQuery = (values: SearchableValue[], query: string): boolean => {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const searchableText = values
    .filter((value) => value !== null && value !== undefined && value !== '')
    .map((value) => String(value).toLowerCase())
    .join(' | ');
  return terms.every((term) => searchableText.includes(term));
};
